import { ReferenceManyField, Datagrid, TextField } from 'react-admin';

export const PrintingTagsList = () => (
  <ReferenceManyField reference="tags" target="printingId" label="">
    <Datagrid rowClick="show" bulkActionButtons={false}>
      <TextField source="tag" label="Tag" sortable={false} />
      <TextField source="material" label="Material" sortable={false} />
      <TextField source="color" label="Color" sortable={false} />
      <TextField source="profileVersion" label="Profile" sortable={false} />
    </Datagrid>
  </ReferenceManyField>
);
